import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from "react-router-dom";
import Loading from '../components/Loading';
import { useStateContext } from '../contexts/ContextProvider';
import axiosClient from '../axios-client';
import Alert from '../components/Alert';
import { Button } from '../components';
import { IoMdLogIn } from 'react-icons/io';
import Icon from '../data/icon.png';
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
const Login = () => {
  const navigate = useNavigate();
  const [loadin, setLoading] = useState(false);
  const usernameRef=useRef();
  const passwordRef=useRef();
  const {setToken,setUser}=useStateContext();
  const [errors,setErrors]=useState(null);
  const [fireToken,setFireToken]=useState(null);
  const firebaseConfig = {
    apiKey: "AIzaSyD8lrQYfQxKh_teGwuiOLKTcaKFHQM5zkw",
    authDomain: "cainotification.firebaseapp.com",
    projectId: "cainotification",
    storageBucket: "cainotification.appspot.com",
    messagingSenderId: "985679398235",
    appId: "1:985679398235:web:3561ed323a7db70dbc467e",
    measurementId: "G-06HLFD43RR"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);
  const requestPermission = () => {

    console.log('requesting user permission');
    Notification.requestPermission().then(permission => {
      console.log("dsafdsfds");
      if (permission === "granted") {
        console.log("granted");
        getToken(messaging,).then(currentToken => {
          if (currentToken) {
            console.log("hohohohohoh:"+currentToken);
            setFireToken(currentToken);

          } else {
            console.log("Faiiiiiled");
          }
        }).catch(err => {
          console.log("dfsgdffsgs" + err);
        })
      } else {
        console.log("deniiiiiide");
      }
    })
  };

  useEffect(()=>{
    requestPermission();
  },[]);
  const login = (ev) => {
    ev.preventDefault();
    setErrors(null);
    setLoading(true);
    const payload = {
      username: usernameRef.current.value,
      password: passwordRef.current.value,
      fireTok:fireToken,
    };
    axiosClient.post('/login', payload)
      .then((data) => {
        setUser(data.data.user);
        setToken(data.data.token);
      })
      .catch(err => {
        const response = err.response;
        if (response && response.status === 422) {
          setErrors(response.data.errors);
        }
        setLoading(false);
      });

  }

  // const login = (ev) => {
  //   ev.preventDefault();
  //   setErrors(null);
  //   setLoading(true);
  //   const payload={
  //     username:usernameRef.current.value,
  //     password:passwordRef.current.value,
  //   };
  //   axiosClient.post('/login',payload)
  //   .then((data)=>{
  //     setUser(data.data.user);
  //     setToken(data.data.token);
  //   })
  //   .catch(err=>{
  //     const response=err.response;
  //     if(response && response.status===422){
  //       setErrors(response.data.errors);
  //     }
  //     setLoading(false);
  //   });
    
  // }

  const handleRimlogClick = () => {
    window.location.href = "https://rimlog.net";
  };
  
  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 to-purple-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 transform transition-all duration-300 hover:scale-105">
        <div className="flex flex-col items-center">
          <img className="h-24 w-auto mb-6 animate-pulse" src={Icon} alt="Company Logo" />
          <h2 className="text-3xl font-extrabold text-gray-900 mb-8">Se connecter</h2>
        </div>

        <div className="space-y-6">
          {errors && Object.keys(errors).map(key => (
            <Alert key={key} message={errors[key][0]} />
          ))}
          
          <div className="space-y-6" onSubmit={login}>
            <div>
              <label className="block text-sm font-medium text-gray-700">User Name (Tel)</label>
              <input
                ref={usernameRef}
                type="text"
                autoComplete="username"
                required
                className="mt-1 block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                placeholder="Entrez votre Username (Tel)"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Mot de passe</label>
              <input
                ref={passwordRef}
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="mt-1 block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                placeholder="Entrez votre mot de passe"
              />
            </div>

            <div>
              {loadin ? (
                <Loading />
              ) : (
                <Button
                  onClick={login}
                  width="w-full"
                  color="bg-blue-600 hover:bg-blue-700"
                  icon={<IoMdLogIn className="mr-2" />}
                  size="20"
                  text="Se connecter"
                  textColor="text-white"
                  className="py-3 rounded-lg transition duration-200"
                />
              )}
            </div>
          </div>
          <div className="text-center mt-6">
            <p
              className="text-sm text-gray-500 cursor-pointer hover:text-blue-600 transition duration-200"
              onClick={handleRimlogClick}
            >
              Supported by Rimlog
            </p>
            <img
              className="h-12 w-auto mx-auto mt-2 cursor-pointer hover:opacity-80 transition duration-200"
              src="https://rimlog.net/assets/img/logo.png"
              alt="Rimlog Logo"
              onClick={handleRimlogClick}
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Login